import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { OrganizationsTableProps } from '../OrganizationsTable.types'

import { OrganisationTypes } from '@percent/domain/verifications'

const allTypes = Object.values(OrganisationTypes) as string[]

export const useOrgTypesFilter = ({
  queryParams,
  setQueryParams
}: Pick<OrganizationsTableProps, 'queryParams' | 'setQueryParams'>) => {
  const { t } = useTranslation()

  const typesOptions = useMemo(
    () => [
      { label: t('organisationTypes.nonprofit'), value: OrganisationTypes.Nonprofit },
      { label: t('organisationTypes.social_impact'), value: OrganisationTypes.SocialImpact },
      { label: t('organisationTypes.education'), value: OrganisationTypes.Education }
    ],
    [t]
  )

  const onTypeChange = useCallback(
    (types: string[]) =>
      setQueryParams({
        type: types,
        page: 1
      }),
    [setQueryParams]
  )

  const selectedTypes = queryParams?.type?.length
    ? queryParams.type.filter((val: string | null): val is string => allTypes.includes(val as string))
    : allTypes

  return {
    typesOptions,
    onTypeChange,
    selectedTypes
  }
}
